import React from 'react';
import { connect } from 'react-redux';

import './source-span.scss';
import enhanceWithClickOutside from 'react-click-outside';
import { REDUCER_NAME } from '../reducer';
class SourceSpan extends React.PureComponent {
  constructor(props) {
    super(props);
    const {
      filterOption: { filterValue },
    } = props;
    const selectOne = !!filterValue;
    const selectAll = !filterValue;

    this.initialState = {
      isShowPopup: false,
      listCheckBox: [
        {
          id: 1,
          title: 'SORT TAG',
          name: this.props.text,
          checked: selectOne,
        },
        {
          id: 2,
          title: 'SHOW ALL',
          name: 'getAll',
          checked: selectAll,
        },
      ],
    };
    this.state = this.initialState;
  }

  componentWillReceiveProps(nextProps) {
    const { filterOption, text } = this.props;
    if (
      !filterOption.filterKey &&
      filterOption.filterKey !== nextProps.filterOption.filterKey
    ) {
      this.setCheckboxStatus(nextProps.filterOption);
    } else {
      this.setState(
        {
          listCheckBox: [
            {
              id: 1,
              title: 'SORT TAG',
              name: text,
              checked: false,
            },
            {
              id: 2,
              title: 'SHOW ALL',
              name: 'getAll',
              checked: true,
            },
          ],
        },
        () => this.toggleShowPopup(false),
      );
    }
  }

  setCheckboxStatus = () => {
    const { text } = this.props;
    const selectOne = [
      {
        id: 1,
        title: 'SORT TAG',
        name: text,
        checked: true,
      },
      {
        id: 2,
        title: 'SHOW ALL',
        name: 'getAll',
        checked: false,
      },
    ];

    const newState = {
      listCheckBox: selectOne,
    };
    this.setState({ ...newState }, () => this.toggleShowPopup(false));
  };

  toggleShowPopup = isShowPopup => {
    if (this.state.isShowPopup !== isShowPopup) {
      this.setState({ isShowPopup });
    }
  };

  handleClickOutside = () => {
    if (this.state.isShowPopup) {
      this.toggleShowPopup(false);
    }
  };

  handleFilter = (key, value) => {
    const { setFilterNewValue } = this.props;
    setFilterNewValue(key, value);
  };

  handleClickCheckBox = index => {
    const listCheckBoxUpdated = [...this.state.listCheckBox];
    const item = listCheckBoxUpdated[index - 1];
    const key = index - 1 === 0 ? 'sourceCode' : null;
    const value = index - 1 === 0 ? item.name : null;
    this.handleFilter(key, value);
  };

  render() {
    const { text } = this.props;
    const { isShowPopup, listCheckBox } = this.state;
    const classNamePopup = isShowPopup ? 'dropdown-menu show' : 'dropdown-menu';
    return (
      <div
        className="group-action-ticker d-flex justify-content-center"
        style={{ padding: '4px 0px' }}
      >
        <div className="item-btn" style={{ opacity: 'unset' }}>
          <div className="dropdown">
            <span
              className={`btn-label-cus text-center text-custom-color`}
              style={{
                cursor: 'pointer',
                width: 120,
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
              }}
              onClick={() => this.toggleShowPopup(true)}
              aria-haspopup="true"
              aria-expanded="false"
              title={text}
            >
              {text}
            </span>
            <div
              className={classNamePopup}
              aria-labelledby="dropdownMenuButton"
              style={{
                position: 'absolute',
                transform: 'translate3d(5px, 15px, 0px)',
                background: '#232931',
                top: '-53px',
                left: '-100px',
                willChange: 'transform',
                cursor: 'pointer',
                minWidth: 90,
                border: 'solid 0.5px #555555',
              }}
            >
              <div className="list-check">
                {listCheckBox.map((item, index) => (
                  <div key={`checkbox-${index}`} className="checkbox">
                    <input
                      checked={item.checked}
                      onChange={() => {
                        if (item.checked) return;
                        this.handleClickCheckBox(item.id);
                      }}
                      id={`checkbox-${index}`}
                      type="checkbox"
                      style={{ cursor: 'pointer' }}
                    />
                    <label
                      htmlFor={`checkbox-${index}`}
                      style={{ cursor: 'pointer' }}
                    >
                      {item.title}
                    </label>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    filterOption: state[REDUCER_NAME].filterOption,
  };
};

export default connect(mapStateToProps)(enhanceWithClickOutside(SourceSpan));
